<template>
  <section class="alert alert-info">
    <strong>Heads up!</strong> Right now you're in readonly mode. You can look, but can't touch. If you want to be able to use the tool yourself, <router-link to="/register">register</router-link> to get started with your 14 day free trial.
  </section>
</template>

<script>
export default {
  name: 'readonly-alert',
};
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/utilities/readonly-alert.vue